module.exports = __webpack_public_path__ + "img/computer_edited.80268275.jpg";